import React from "react";
import { Box, Divider, Stack } from "digiwash-components";
import BoxRatio from "../BoxRatio";

import {
  boxRatioWidth,
  suggestResponsiveBoxRatioForCategories,
  suggestResponsiveColumnForCategories,
} from "../../helpers/general";

function SkeletonCategories() {
  let loadingArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  let categories = suggestResponsiveBoxRatioForCategories();

  return (
    <Stack
      distribution="space-between"
      style={{ flexWrap: "wrap" }}
      columns={suggestResponsiveColumnForCategories(categories.column)}
      fillIfEmpty
    >
      {loadingArray.map((index) => {
        return (
          <Box key={index}>
            <Box py="l">
              <BoxRatio
                ratio="2:1.84"
                fixedWidth={boxRatioWidth({
                  columns: categories.column,
                  padding: categories.padding,
                })}
              >
                <Box
                  bg="neutrals.250"
                  br="m"
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                ></Box>
              </BoxRatio>
              <Divider size="l" />
              <Stack>
                <Box
                  bg="neutrals.250"
                  br="l"
                  style={{ width: 88, height: 19 }}
                ></Box>
              </Stack>
              <Divider size="l" />
            </Box>
          </Box>
        );
      })}
    </Stack>
  );
}

export default SkeletonCategories;
